module.exports = __webpack_public_path__ + "img/swine-site2.7718b664.svg";